export default "/kiban/_next/static/images/top_white-afc56f7d8e179d9280fcffbefb0ff04e.png";